import React from 'react'
import './List.css';
import { v4 as uuid } from 'uuid';
import { useState } from 'react';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
function List(props) {
    const uniqId = uuid();
    const [TotalMoney, setTotalMoney] = useState(0)
    const [RestMoney, setRestMoney] = useState(0)
    const [toDo, settoDo] = useState([]);

    // temp state
    const [newTask, setnewTask] = useState('');
    const [newNum, setnewNum] = useState('');

    // Add function
    const addTask = (newTask, newNum) => {
        const myTodo = {
            id: uniqId,
            title: newTask,
            money: newNum,
            Status: false
        }

        if (parseInt(RestMoney)-parseInt(newNum) >= 0) {
            settoDo([...toDo, myTodo]);
            setnewTask('');
            setnewNum('');
        }
        if (parseInt(RestMoney)-parseInt(newNum) < 0) {
            alert("Your Total Money is Finished");
            setTotalMoney(parseInt(0));
            setRestMoney(parseInt(0));
            settoDo([]);
            setnewTask('');
            setnewNum('');
        }
        else if (newNum < 0) {
            setTotalMoney(parseInt(TotalMoney) - parseInt(newNum));
            setRestMoney(parseInt(RestMoney) - parseInt(newNum));
        }
        else
            setRestMoney(parseInt(RestMoney) - parseInt(newNum))
    }
    // Delete function
    const deleteTask = (index) => {
        const newTasks = [...toDo];
        newTasks.splice(index, 1);
        settoDo(newTasks);
    }
    return (
        <div className='listMoney'>
            <div className="card">
                <div className="text tM">
                    <span>Total Money</span>
                    <span>
                        ${TotalMoney}
                    </span>
                </div>
                <div className="text rM">
                    <span>
                        Rest Money
                    </span>
                    <span>
                        ${RestMoney}
                    </span>
                </div>
            </div>
            <hr />
            {/* display list */}
            {toDo && toDo.length ? '' : 'Firstly Add Money putting number with - sign'}
            {toDo && toDo.map((task, index) => {
                return (
                    <React.Fragment key={task.id}>
                        <div className="col taskBag">
                            <div className={task.status ? 'itemList' : ''} >
                                <span className="taskNumber"> {index + 1} </span>
                                <span className="taskText"> {task.title} </span>
                                <span className="taskNum"> {task.money}INR </span>
                                <div className='delIcon' >
                                    <div className={task.money > 0 ? 'gain' : 'loss'}>{task.money < 0 ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}</div>
                                    <button onClick={() => { deleteTask(index) }} >
                                        <DeleteSweepIcon />
                                    </button>
                                </div>
                            </div>
                        </div>

                    </React.Fragment>
                )
            })
            }
            <hr className='hr2' />
            {/* Form for input data */}
            <form action="" type="submit" onSubmit={(event) => { event.preventDefault(); addTask(newTask, newNum) }}>
                <input type="text" value={newTask} onChange={(e) => { setnewTask(e.target.value) }} placeholder='Write spend Amount reason' className='textWala' />
                <input type="number" value={newNum} onChange={(e) => { setnewNum(e.target.value) }} name="number" id="" placeholder='$...' className='NumWala' />
                <button type='submit'> <AddCircleIcon /> </button>
            </form>
        </div>
    )
}

export default List